/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateSupervisorRequestDto } from '../models';
// @ts-ignore
import type { EmailAvailabilityDto } from '../models';
// @ts-ignore
import type { ErrorResponseDto } from '../models';
// @ts-ignore
import type { SupervisorDto } from '../models';
// @ts-ignore
import type { SupervisorIdDto } from '../models';
// @ts-ignore
import type { SupervisorSearchRequestDto } from '../models';
// @ts-ignore
import type { SupervisorSearchResponseDto } from '../models';
// @ts-ignore
import type { UpdateSupervisorRequestDto } from '../models';
/**
 * RestSupervisorsApi - axios parameter creator
 */
export const RestSupervisorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSupervisorRequestDto} createSupervisorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupervisor: async (createSupervisorRequestDto: CreateSupervisorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSupervisorRequestDto' is not null or undefined
            assertParamExists('createSupervisor', 'createSupervisorRequestDto', createSupervisorRequestDto)
            const localVarPath = `/api/supervisors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupervisorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} supervisorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupervisor: async (supervisorId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisorId' is not null or undefined
            assertParamExists('getSupervisor', 'supervisorId', supervisorId)
            const localVarPath = `/api/supervisors/{supervisorId}`
                .replace('{supervisorId}', encodeURIComponent(String(supervisorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {number} [excludeSupervisorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupervisorEmailAvailability: async (email: string, excludeSupervisorId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getSupervisorEmailAvailability', 'email', email)
            const localVarPath = `/api/supervisors/email-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (excludeSupervisorId !== undefined) {
                localVarQueryParameter['excludeSupervisorId'] = excludeSupervisorId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SupervisorSearchRequestDto} supervisorSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupervisors: async (page: number, pageSize: number, supervisorSearchRequestDto: SupervisorSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchSupervisors', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchSupervisors', 'pageSize', pageSize)
            // verify required parameter 'supervisorSearchRequestDto' is not null or undefined
            assertParamExists('searchSupervisors', 'supervisorSearchRequestDto', supervisorSearchRequestDto)
            const localVarPath = `/api/supervisors/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supervisorSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} supervisorId 
         * @param {UpdateSupervisorRequestDto} updateSupervisorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupervisor: async (supervisorId: number, updateSupervisorRequestDto: UpdateSupervisorRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisorId' is not null or undefined
            assertParamExists('updateSupervisor', 'supervisorId', supervisorId)
            // verify required parameter 'updateSupervisorRequestDto' is not null or undefined
            assertParamExists('updateSupervisor', 'updateSupervisorRequestDto', updateSupervisorRequestDto)
            const localVarPath = `/api/supervisors/{supervisorId}`
                .replace('{supervisorId}', encodeURIComponent(String(supervisorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSupervisorRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestSupervisorsApi - functional programming interface
 */
export const RestSupervisorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestSupervisorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateSupervisorRequestDto} createSupervisorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSupervisor(createSupervisorRequestDto: CreateSupervisorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisorIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSupervisor(createSupervisorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSupervisorsApi.createSupervisor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} supervisorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupervisor(supervisorId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisorDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupervisor(supervisorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSupervisorsApi.getSupervisor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {number} [excludeSupervisorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupervisorEmailAvailability(email: string, excludeSupervisorId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailAvailabilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupervisorEmailAvailability(email, excludeSupervisorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSupervisorsApi.getSupervisorEmailAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SupervisorSearchRequestDto} supervisorSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSupervisors(page: number, pageSize: number, supervisorSearchRequestDto: SupervisorSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisorSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSupervisors(page, pageSize, supervisorSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSupervisorsApi.searchSupervisors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} supervisorId 
         * @param {UpdateSupervisorRequestDto} updateSupervisorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupervisor(supervisorId: number, updateSupervisorRequestDto: UpdateSupervisorRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupervisor(supervisorId, updateSupervisorRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSupervisorsApi.updateSupervisor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestSupervisorsApi - factory interface
 */
export const RestSupervisorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestSupervisorsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateSupervisorRequestDto} createSupervisorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupervisor(createSupervisorRequestDto: CreateSupervisorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupervisorIdDto> {
            return localVarFp.createSupervisor(createSupervisorRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} supervisorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupervisor(supervisorId: number, options?: RawAxiosRequestConfig): AxiosPromise<SupervisorDto> {
            return localVarFp.getSupervisor(supervisorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {number} [excludeSupervisorId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupervisorEmailAvailability(email: string, excludeSupervisorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EmailAvailabilityDto> {
            return localVarFp.getSupervisorEmailAvailability(email, excludeSupervisorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SupervisorSearchRequestDto} supervisorSearchRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupervisors(page: number, pageSize: number, supervisorSearchRequestDto: SupervisorSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupervisorSearchResponseDto> {
            return localVarFp.searchSupervisors(page, pageSize, supervisorSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} supervisorId 
         * @param {UpdateSupervisorRequestDto} updateSupervisorRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupervisor(supervisorId: number, updateSupervisorRequestDto: UpdateSupervisorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSupervisor(supervisorId, updateSupervisorRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestSupervisorsApi - interface
 */
export interface RestSupervisorsApiInterface {
    /**
     * 
     * @param {CreateSupervisorRequestDto} createSupervisorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSupervisor(createSupervisorRequestDto: CreateSupervisorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupervisorIdDto>;

    /**
     * 
     * @param {number} supervisorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSupervisor(supervisorId: number, options?: RawAxiosRequestConfig): AxiosPromise<SupervisorDto>;

    /**
     * 
     * @param {string} email 
     * @param {number} [excludeSupervisorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSupervisorEmailAvailability(email: string, excludeSupervisorId?: number, options?: RawAxiosRequestConfig): AxiosPromise<EmailAvailabilityDto>;

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SupervisorSearchRequestDto} supervisorSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchSupervisors(page: number, pageSize: number, supervisorSearchRequestDto: SupervisorSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SupervisorSearchResponseDto>;

    /**
     * 
     * @param {number} supervisorId 
     * @param {UpdateSupervisorRequestDto} updateSupervisorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSupervisor(supervisorId: number, updateSupervisorRequestDto: UpdateSupervisorRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestSupervisorsApi - object-oriented interface
 */
export class RestSupervisorsApi extends BaseAPI implements RestSupervisorsApiInterface {
    /**
     * 
     * @param {CreateSupervisorRequestDto} createSupervisorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSupervisor(createSupervisorRequestDto: CreateSupervisorRequestDto, options?: RawAxiosRequestConfig) {
        return RestSupervisorsApiFp(this.configuration).createSupervisor(createSupervisorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} supervisorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupervisor(supervisorId: number, options?: RawAxiosRequestConfig) {
        return RestSupervisorsApiFp(this.configuration).getSupervisor(supervisorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {number} [excludeSupervisorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupervisorEmailAvailability(email: string, excludeSupervisorId?: number, options?: RawAxiosRequestConfig) {
        return RestSupervisorsApiFp(this.configuration).getSupervisorEmailAvailability(email, excludeSupervisorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SupervisorSearchRequestDto} supervisorSearchRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchSupervisors(page: number, pageSize: number, supervisorSearchRequestDto: SupervisorSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestSupervisorsApiFp(this.configuration).searchSupervisors(page, pageSize, supervisorSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} supervisorId 
     * @param {UpdateSupervisorRequestDto} updateSupervisorRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSupervisor(supervisorId: number, updateSupervisorRequestDto: UpdateSupervisorRequestDto, options?: RawAxiosRequestConfig) {
        return RestSupervisorsApiFp(this.configuration).updateSupervisor(supervisorId, updateSupervisorRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

